import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'
import SanitizedHtml from '../../html-sanitizer'

export const GenericHtmlContent = ({bodycopy, maxWidth = remCalc(1920)}) => (
    <SanitizedHtml
        as={Box}
        data-testid="generic-html-content"
        maxW={maxWidth}
        m="auto"
        html={bodycopy}
    />
)

GenericHtmlContent.propTypes = {
    bodycopy: PropTypes.string,
    maxWidth: PropTypes.string,
}
